import { DatePipe, DOCUMENT, NgOptimizedImage } from '@angular/common';
import { Component, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-analytehealth-layout',
  templateUrl: './analytehealth-layout.component.html',
  styleUrls: ['./analytehealth-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe, NgOptimizedImage],
})
export class AnalytehealthLayoutComponent {
  public mobileMenuActive: boolean = false;
  public today: Date = new Date();

  private document = inject<Document>(DOCUMENT);

  /**
   * Gets the phone number digits for the tel href.
   */
  public get phoneNumberDigits(): string {
    return environment.phone.replace(/[^0-9]/g, '');
  }

  /**
   * Gets the brand's customer service phone number.
   */
  public get phoneNumber(): string {
    return environment.phone;
  }

  /**
   * Gets the AnalyteHealth marketing site URL used for the logo and navigation links.
   */
  public get siteUrl(): string {
    return 'https://www.analytehealth.com';
  }

  /**
   * Closes the drawer with the Escape key, matching the source theme's accessibility behaviour.
   */
  @HostListener('document:keydown.escape')
  public onEscape(): void {
    this.closeMenu();
  }

  /**
   * Closes the drawer when the viewport is resized back up to desktop widths.
   */
  @HostListener('window:resize')
  public onResize(): void {
    if (this.mobileMenuActive && window.innerWidth >= 1024) {
      this.closeMenu();
    }
  }

  /**
   * Toggles the mobile navigation drawer and locks/unlocks page scroll while it is open.
   */
  public toggleMenu(): void {
    this.mobileMenuActive = !this.mobileMenuActive;
    this.document.body.style.overflow = this.mobileMenuActive ? 'hidden' : '';
  }

  /**
   * Closes the mobile navigation drawer.
   */
  public closeMenu(): void {
    if (!this.mobileMenuActive) {
      return;
    }

    this.mobileMenuActive = false;
    this.document.body.style.overflow = '';
  }
}
